import { useSyncExternalStore } from 'react';
import { MOBILE_SHELL_MAX_WIDTH, usesMobileShell } from '../constants/breakpoints';
import { platform } from '../lib/native';

const query = `(max-width: ${MOBILE_SHELL_MAX_WIDTH}px)`;

const read = () => usesMobileShell({
  viewportWidth: typeof window === 'undefined' ? Infinity : window.innerWidth,
  isNative: platform.isNative,
});

const subscribe = (onChange) => {
  if (typeof window === 'undefined') return () => {};
  const list = window.matchMedia(query);
  list.addEventListener('change', onChange);
  return () => list.removeEventListener('change', onChange);
};

/**
 * True when the phone shell owns navigation: bottom tabs instead of the
 * sidebar, sheets instead of hover affordances, edge-to-edge content.
 *
 * The decision itself lives in constants/breakpoints.js so web and native read
 * the same rule; this hook only makes it reactive.
 */
export function useMobileShell() {
  return useSyncExternalStore(subscribe, read, () => false);
}

export default useMobileShell;
